import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search model for Inventory group
 */
@Injectable()
export class InventoryGroupSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "invGroupId";
    }
}
